import React, { Component } from 'react'
import { connect } from 'react-redux'
import { SET_DEPOT } from '@/action-types/depot'
import BaseHeader from '@/components/base-header'
import Cookies from 'universal-cookie'
import { BrowserRouter as Router } from 'react-router-dom'
// import Gesture from 'rc-gesture'
import './layout.less'
import { GlobalHistory } from '../global-history'

const mapStateToProps = () => ({})

const mapDispatchToProps = (dispatch: any) => ({
  defaultDepotAction: (payload: any) => dispatch({ type: SET_DEPOT, payload }),
})

@(connect(
  mapStateToProps,
  mapDispatchToProps,
) as any)
export default class Layout extends Component {
  constructor(props: any) {
    super(props)
    this.getDefaultDepot()
  }
  async getDefaultDepot() {
    const cookies = new Cookies()
    const id = cookies.get('app_mall_depot_id')
    const title = cookies.get('app_mall_depot_name')
    const { defaultDepotAction }: any = this.props
    defaultDepotAction({ id, title })
  }
  render() {
    const { children } = this.props
    return (
      <Router>
        <GlobalHistory />
        <BaseHeader />
        {/* <Gesture
          onSwipeRight={(gestureStatus) => { console.log(12312); }}
        > */}
          {/* <div style={{height: '100vh',width:'100vw',background:'#ff0'}}>sdasd</div> */}
          {children}
        {/* </Gesture> */}
      </Router>
    )
  }
}
